import Gallery from "./woocommerce/product/Gallery";
import Lightbox from "./woocommerce/product/Lightbox";
import Quantity from "./woocommerce/Quantity";
import Variables from "./woocommerce/product/Variables";

document.addEventListener("DOMContentLoaded", async () => {
  await new Gallery().init();
  await new Variables().init();
  await new Lightbox().init();
  await new Quantity().init();

  await handleReviews();
  await handleScrollToReviews();
  await handleVideosSlider();
  await handleProductsSlider();
  await handleConfigurator();
  await handleMoveToConfigurator();
  await handleFixedPrice();

  window.addEventListener("product_hot_reload", async () => {
    await handleReviews();
    await handleScrollToReviews();
    await handleVideosSlider();
    await handleProductsSlider();
    await handleMoveToConfigurator();
    await handleFixedPrice();

    window.removeEventListener("product_hot_reload", () => {});
  });
});

const handleReviews = async () => {
  const reviewsRoot = document.querySelector(".reviews-accordion__list") as HTMLElement;
  if (reviewsRoot.innerHTML.trim() !== "") {
    const { default: Reviews } = await import("./woocommerce/product/Reviews");
    await new Reviews().init();
  }
};

const handleScrollToReviews = async () => {
  const reviewCountButton = document.querySelector(".review-count") as HTMLElement;
  if (!reviewCountButton) return;

  reviewCountButton.addEventListener("click", () => {
    const reviews = document.querySelector(".accordion--reviews") as HTMLElement,
      header = document.querySelector("header") as HTMLElement,
      accordionHeader = reviews.querySelector(".accordion__header") as HTMLElement;

    scrollTo({ top: reviews.offsetTop + header.offsetHeight - 40, behavior: "smooth" });
    if (!reviews.classList.contains("active")) accordionHeader.click();
  });
};

const handleVideosSlider = async () => {
  const videosSlider = document.querySelector(".slider-with-videos") as HTMLElement;

  if (!videosSlider) return;

  const { default: VideosSlider } = await import("./components/Sliders/VideosSlider");
  await new VideosSlider().init();
};

const handleProductsSlider = async () => {
  const productsSlider = document.querySelector(".product-list-slider") as HTMLElement;
  if (!productsSlider) return;

  const { default: ProductListSlider } = await import("./components/Sliders/ProductListSlider");
  await new ProductListSlider().init();
};

const handleConfigurator = async () => {
  const configuratorRoot = document.getElementById("configurator") as HTMLElement;
  if (configuratorRoot) {
    const { default: Configurator } = await import("./woocommerce/product/Configurator");
    await new Configurator().init(configuratorRoot);
  }
};

const handleMoveToConfigurator = async () => {
  const configuratorButton = document.querySelector(".move-to-configurator") as HTMLElement;
  if (!configuratorButton) return;

  configuratorButton.addEventListener("click", () => {
    const configurator = document.getElementById("configurator") as HTMLElement,
      header = document.querySelector("header") as HTMLElement;
    scrollTo({ top: configurator.offsetTop + header.offsetHeight - 40, behavior: "smooth" });
  });

  if (window.location.search) configuratorButton.click();
};

const handleFixedPrice = async () => {
  const price = document.querySelector("#product-price") as HTMLElement;
  const fixablePrice = document.querySelector(".fixable-price") as HTMLElement;
  if (!fixablePrice) return;

  //add active class to fixable price when price is hidden by top screen edge
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (innerWidth < 1024) {
          if (entry.isIntersecting) {
            fixablePrice.classList.remove("active");
          } else {
            fixablePrice.classList.add("active");
          }
        }
      });
    },
    { threshold: [0] }
  );

  observer.observe(price);

  const copiedPrice = fixablePrice.querySelector(".copied-price") as HTMLElement;
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        copiedPrice.innerHTML = price.innerHTML;
      }
    });
  });

  mutationObserver.observe(price, { childList: true });
};
